module.exports = __webpack_public_path__ + "static/media/Q6.4be1dcf5.png";